import React from "react";
import HrNav from "./HrNav";
import HrSidebar from './HrSidebaar';
import HrDashboardRoutes from "../HrDashBoard/HrDashBoardRoutes";
import "../../Styles/HrDashboardLayout.css";

function HrDashboardLayout() {
  return (
    <div className="hr-layout">
      <HrNav />
      <HrSidebar />

      <main className="hr-main-content">
        <HrDashboardRoutes />
      </main>
    </div>
  );
}

export default HrDashboardLayout;